module.exports = __webpack_public_path__ + "img/u_exclamation-triangle.2fbfba3f.svg";